import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  private loadedScripts: { [url: string]: boolean } = {};
  private loadingScripts: { [url: string]: Promise<void> } = {};

  loadScript(url: string): Promise<void> {
    if (this.loadedScripts[url]) {
      return Promise.resolve();
    }

    if (this.loadingScripts[url]) {
      return this.loadingScripts[url];
    }

    const promise = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = () => {
        this.loadedScripts[url] = true;
        delete this.loadingScripts[url];
        resolve();
      };
      script.onerror = () => {
        delete this.loadingScripts[url];
        reject(new Error(`Failed to load script: ${url}`));
      };
      document.head.appendChild(script);
    });

    this.loadingScripts[url] = promise;
    return promise;
  }

  async loadOzonetelSDK(): Promise<void> {
    await this.loadJsSIP();
    await this.loadScript('https://dc-sdk.cloudagent.ozonetel.com/digitalConsole.js');
    await this.loadScript('./assets/js/onecxi.common.min.js');
  }

  async loadJsSIP(): Promise<void> {
    if ((window as any).JsSIP?.UA) {
      return;
    }
    const mod: any = await import('jssip');
    (window as any).JsSIP = mod.default || mod;
  }
}
